var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "user_svg__Layer_1",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user_svg__st1{fill:#fff}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#6085f0"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.769,
    cy: 13.442,
    r: 5.541,
    className: "user_svg__st1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.208 20.59-1.2.447a3.9 3.9 0 0 1-1.673.024l-1.388-.473c-.6-.205-1.245-.287-1.872-.187-3.257.516-5.64 3.02-5.64 6.423v.731c0 1.192.966 2.158 2.158 2.158H27.65a1.914 1.914 0 0 0 1.915-1.914v-.983c0-3.424-2.394-5.937-5.64-6.42a3.5 3.5 0 0 0-1.717.195",
    className: "user_svg__st1"
  })));
};
export default SvgUser;